import { atom } from "recoil";

export const imageLibState = atom({
    key: "image_lib",
    default: {
        source: "collection",
    },
});
